import { Editor } from 'slate';

export default function getLastNode(editor, options) {
  // `Editor.nodes` returns a generator - each iteration of the loop, it yields the next node.
  // So we loop and return the first node iterated over.. somehow this is the cleanest way.
  for (const nodeEntry of Editor.nodes(editor, { reverse: true, ...options })) {
    return nodeEntry;
  }
  return null;
}
